import { createSlice } from "@reduxjs/toolkit";
const sigSlice = createSlice({
  name: "sigGroup",

  //intial state
  initialState: {
    sigDetails: {},
    allSig: [],
    sigRoleDetails: {},
  },

  //reducer
  reducers: {
    setSigDetails: (state, action) => {
      state.sigDetails = action.payload;
    },
    setAllSig: (state, action) => {
      state.allSig = action.payload;
    },
    setSigRoleDetails: (state, action) => {
      state.sigRoleDetails = action.payload;
    },
  },
});

export default sigSlice.reducer;
export const { setSigDetails } = sigSlice.actions;
export const { setSigRoleDetails } = sigSlice.actions;
export const { setAllSig } = sigSlice.actions;
export const selectCurrentSig = (state) => state?.sig?.sigDetails;
export const selectCurrenSigRole = (state) => state.sig?.sigRoleDetails;
export const getAllSig = (state) => state?.sig?.allSig;
